// SPDX-License-Identifier: MIT
// Desktop-only sync metadata (a single global lastSyncedAt = the last successful
// pullDesktopFromCloud), backed by sync-meta.json via Rust get_sync_meta/set_sync_meta.
// Web has no such store; callers guard on platform before reading.
import { tauriInvoke } from './tauri';

interface SyncMeta { lastSyncedAt?: string }

export async function getLastSyncedAt(): Promise<string | null> {
  const raw = await tauriInvoke()('get_sync_meta');
  if (typeof raw !== 'string' || raw.length === 0) return null;
  try { return (JSON.parse(raw) as SyncMeta).lastSyncedAt ?? null; } catch { return null; }
}

export async function setLastSyncedAt(iso: string): Promise<void> {
  await tauriInvoke()('set_sync_meta', { json: JSON.stringify({ lastSyncedAt: iso } satisfies SyncMeta) });
}
